"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactNative = require("react-native");

var _CircularProgress = _interopRequireDefault(require("./CircularProgress"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var AnimatedProgress = _reactNative.Animated.createAnimatedComponent(_CircularProgress["default"]);

var AnimatedCircularProgress = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(AnimatedCircularProgress, _React$PureComponent);

  var _super = _createSuper(AnimatedCircularProgress);

  function AnimatedCircularProgress(props) {
    var _this;

    _classCallCheck(this, AnimatedCircularProgress);

    _this = _super.call(this, props);
    _this.state = {
      fillAnimation: new _reactNative.Animated.Value(props.prefill)
    };
    return _this;
  }

  _createClass(AnimatedCircularProgress, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.animate();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.fill !== this.props.fill) {
        this.animate();
      }
    }
  }, {
    key: "reAnimate",
    value: function reAnimate(prefill, toVal, dur, ease) {
      var _this2 = this;

      this.setState({
        fillAnimation: new _reactNative.Animated.Value(prefill)
      }, function () {
        return _this2.animate(toVal, dur, ease);
      });
    }
  }, {
    key: "animate",
    value: function animate(toVal, dur, ease) {
      var toValue = toVal >= 0 ? toVal : this.props.fill;
      var duration = dur || this.props.duration;
      var easing = ease || this.props.easing;
      var useNativeDriver = this.props.useNativeDriver;

      var anim = _reactNative.Animated.timing(this.state.fillAnimation, {
        useNativeDriver: useNativeDriver,
        toValue: toValue,
        easing: easing,
        duration: duration
      });

      anim.start(this.props.onAnimationComplete);
      return anim;
    }
  }, {
    key: "animateColor",
    value: function animateColor() {
      if (!this.props.tintColorSecondary) {
        return this.props.tintColor;
      }

      var tintAnimation = this.state.fillAnimation.interpolate({
        inputRange: [0, 100],
        outputRange: [this.props.tintColor, this.props.tintColorSecondary]
      });
      return tintAnimation;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          fill = _this$props.fill,
          prefill = _this$props.prefill,
          other = _objectWithoutProperties(_this$props, ["fill", "prefill"]);

      return /*#__PURE__*/_react["default"].createElement(AnimatedProgress, _extends({}, other, {
        fill: this.state.fillAnimation,
        tintColor: this.animateColor()
      }));
    }
  }]);

  return AnimatedCircularProgress;
}(_react["default"].PureComponent);

exports["default"] = AnimatedCircularProgress;
AnimatedCircularProgress.propTypes = _objectSpread(_objectSpread({}, _CircularProgress["default"].propTypes), {}, {
  prefill: _propTypes["default"].number,
  duration: _propTypes["default"].number,
  easing: _propTypes["default"].func,
  onAnimationComplete: _propTypes["default"].func,
  useNativeDriver: _propTypes["default"].bool
});
AnimatedCircularProgress.defaultProps = {
  duration: 500,
  easing: _reactNative.Easing.out(_reactNative.Easing.ease),
  prefill: 0,
  useNativeDriver: false
};